<template>
    <div class="yarnboard">
        <VideoContainer :clip="clip" :nextRoute="nextRoute" />
    </div>
</template>

<script>
import VideoContainer from '@/components/VideoContainer.vue'
import Clip from '@/assets/Yarn3.mp4'

export default {
    name: 'yarnboard3',
    components: {
        VideoContainer
    },
    data() {
        return {
            clip: Clip,
            nextRoute: "/cargo-van"
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
